import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { OrdonnanceDto } from '../DTO/ordonnance.dto';
import {combineAll, map} from 'rxjs/operators';
import { PageDto, Meta } from '../DTO/page.dto';

@Injectable({
  providedIn: 'root'
})
export class OrdonnanceService {

  private ORDONNANCE_ENDPOINT = environment.API_ENDPOINT + '/ordonnances';

  public wantLogout = false;
  isDataLoaded: boolean;

  public metaOrdonnancesList: Meta;

  constructor(private httpClient: HttpClient) {
  }

  getOrdonnancesMe(limit?: string, page?: string) {
    this.isDataLoaded = false;

    const params = new HttpParams()
    .set('limit', limit ? limit : '10')
    .set('page', page ? page : '0');

    return this.httpClient.get(this.ORDONNANCE_ENDPOINT + '/me', {params: params})
    .pipe(
      map((page: PageDto) => {
        this.metaOrdonnancesList = Meta.fromJson(page.meta);
        return page.data;
      }),
      combineAll((ordonnance: any) => {
        return OrdonnanceDto.fromJson(ordonnance);
      })
    );
  }

  putOrdonnanceProcessed(idOrdonnance: number, message: string, copyMail: boolean) {
    return this.httpClient.put(this.ORDONNANCE_ENDPOINT + '/' + idOrdonnance +'/etats/traiter', JSON.stringify({'message': message, 'copyMail': copyMail, 'etatCode': 0}));
  }

  putOrdonnanceRejetee(idOrdonnance: number, message: string, copyMail: boolean, etatCode: number) {
    return this.httpClient.put(this.ORDONNANCE_ENDPOINT + '/' + idOrdonnance +'/etats/rejeter', JSON.stringify({'message': message, 'copyMail': copyMail, 'etatCode': etatCode}));
  }

  putOrdonnanceInformation(idOrdonnance: number, message: string, copyMail: boolean) {
    return this.httpClient.put(this.ORDONNANCE_ENDPOINT + '/' + idOrdonnance +'/etats/information', JSON.stringify({'message': message, 'copyMail': copyMail, 'etatCode': 0}));
  }

}